import { combineReducers } from 'redux';

import { Reducer } from '../../../types';
import { ArticleAction } from '../types';
import { transformDocumentPage } from '../utils';

import {
  getArticleDocumentPagesSuccess,
  getArticleDocumentPagesFail,
  getArticleDocumentPagesRequest,
  setCurrentArticleDocumentPage,
  setCurrentIndexMediaViewer,
} from '../actions';
import { StateDocumentPages } from '../types/documentPages';

type ReducerOf<T extends keyof StateDocumentPages> = Reducer<StateDocumentPages, ArticleAction, T>;

const data: ReducerOf<'data'> = (state = null, action) => {
  switch (action.type) {
    case getArticleDocumentPagesRequest.type:
      return null;
    case getArticleDocumentPagesSuccess.type:
      return transformDocumentPage(action.payload);

    default:
      return state;
  }
};

const current: ReducerOf<'current'> = (state = null, action) => {
  switch (action.type) {
    case getArticleDocumentPagesRequest.type:
    case setCurrentIndexMediaViewer.type:
      return null;
    case getArticleDocumentPagesSuccess.type:
      return (transformDocumentPage(action.payload).length) ? transformDocumentPage(action.payload)[0] : null;
    case setCurrentArticleDocumentPage.type:
      return action.payload;
    default:
      return state;
  }
};

const loading: ReducerOf<'loading'> = (state = false, action) => {
  switch (action.type) {
    case getArticleDocumentPagesRequest.type:
      return true;

    case getArticleDocumentPagesSuccess.type:
    case getArticleDocumentPagesFail.type:
      return false;

    default:
      return state;
  }
};

export default combineReducers<StateDocumentPages>({
  data,
  current,
  loading,
});
